import { FC } from 'react';
import { BBButton } from '../styles';

interface ButtonRowButtonProps {
  name: string;
  selected: boolean;
  onClick: () => void;
  dataTestId?: string;
}

export const ButtonRowButton: FC<ButtonRowButtonProps> = ({
  name,
  selected,
  onClick,
  dataTestId,
}) => {
  return (
    <BBButton data-testid={dataTestId} $selected={selected} onClick={onClick}>
      {name}
    </BBButton>
  );
};
